type Props = {
  label: string;
  count: number;
  total: number;
};

const ShopRatingBar = (props: Props) => {
  const { label, count, total } = props;

  const percentage = total ? (count / total) * 100 : 0;

  // Render image
  return (
    <div className="shop-rating-bar">
      <div>{label}</div>
      <div className="full-bar">
        <div className="count-bar" style={{ width: `${percentage}%` }} />
      </div>
    </div>
  );
};

export default ShopRatingBar;
